import { render, staticRenderFns } from "./AmetrasCheckBoxTemplate.vue?vue&type=template&id=534c7f22&scoped=true&"
import script from "./AmetrasCheckBoxTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasCheckBoxTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasCheckBoxTemplate.vue?vue&type=style&index=0&id=534c7f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c7f22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
